import type { SupWeb3WithdrawSingleVault, SupWithdrawableBalance, SupWithdrawableToken } from "@/types";
import React, { useCallback, useMemo } from "react";

import useTokenSuperpositionsBalances from "@/hooks/api/useTokenSuperpositionsBalances";
import { useStoredData, useStoredDataDispatch } from "@/store";
import { SupButton } from "@repo/core-ui";

interface Web3TransmuteWithdrawTriggerProps {
  selectedBalance?: SupWithdrawableToken | SupWithdrawableBalance;
  vaultList: SupWeb3WithdrawSingleVault[];
}
// eslint-disable-next-line no-empty-pattern
export default function Web3TransmuteWithdrawTrigger({ selectedBalance, vaultList }: Web3TransmuteWithdrawTriggerProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();
  const { data: superPositionBalances, isLoading: superPositionBalancesIsLoading } = useTokenSuperpositionsBalances("cached");

  const singleSuperPosition = useMemo(() => {
    const requireTransmute = storedData.withdrawCart.find(single => !single.is_erc20);
    return superPositionBalances?.superPositions.find(
      superPosition => superPosition.vault.id === requireTransmute?.vault_id && superPosition.chain_id === requireTransmute?.chainId && !superPosition.is_erc20
    );
  }, [storedData.withdrawCart, superPositionBalances?.superPositions]);

  const handleStartTransmute = useCallback(() => {
    if (!singleSuperPosition) {
      return;
    }
    storedDispatch({
      type: "setTransmute",
      transmute: {
        superposition: singleSuperPosition,
        source: "withdraw",
        amount: vaultList[0].amount?.toString(),
        direction: "ERC20",
        targetToken: selectedBalance,
      },
    });
    storedDispatch({ type: "setOverlay", overlay: "transmute" });
    storedDispatch({ type: "clearWithdrawCart" });
  }, [selectedBalance, singleSuperPosition, storedDispatch, vaultList]);
  return (
    <SupButton type="button" fluid onClick={handleStartTransmute} disabled={!singleSuperPosition || superPositionBalancesIsLoading}>
      Transmute to Withdraw
    </SupButton>
  );
}
